import { Icon } from '../../components/Icon';
import { RollingNumber } from '../../components/RollingNumber';
import { useI18n } from '../../i18n/i18n-context';
import { rich } from '../../i18n/rich';

export function RateLimitNotice({ secondsLeft }: { secondsLeft: number }) {
  const { t, format } = useI18n();
  return (
    <div className="empty-state empty-state--warning">
      <span className="empty-icon" aria-hidden="true">
        <Icon name="clock" />
      </span>
      <h3 className="empty-title">{t.rateLimit.title}</h3>
      <p className="empty-description">
        {t.rateLimit.reached}{' '}
        {secondsLeft > 0
          ? rich(t.rateLimit.tryAgainIn, {
              time: (
                <span className="limit-countdown">
                  <RollingNumber value={format.duration(secondsLeft)} />
                </span>
              ),
            })
          : t.rateLimit.now}
      </p>
    </div>
  );
}
